import styles from './AttachmentsTabPanel.module.scss';

import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Attachments } from '@work4all/components/lib/components/attachments';
import { ContextMenu } from '@work4all/components/lib/components/context-menu/ContextMenu';

import { TempFileManagerContext } from '@work4all/data/lib/hooks/data-provider/useTempFileManager';

import { ErpAttachment } from '@work4all/models/lib/Classes/ErpAttachment.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { useTableLayoutState } from '../../../../../../../../components/data-tables/table-layout';
import { CheckboxRadioItem } from '../../../../../../locked-inputs';
import { LockFeature } from '../../../../../components/LockFeature';
import { Panel } from '../../../../../components/panel/Panel';
import { useMaskContext } from '../../../../../hooks/mask-context';

export const AttachmentsTabPanel = () => {
  const { t } = useTranslation();
  const [tableLayout] = useTableLayoutState();
  const mask = useMaskContext();
  const [menuItem, setMenuItem] = useState(null);
  const attachmentsContext = useContext(TempFileManagerContext);
  const attachment = menuItem
    ? (attachmentsContext.fileList.find(
        (x) => x.id.toString() === menuItem.original.id.toString()
      ) as ErpAttachment)
    : null;

  const canModify = (id: number | string) => {
    return attachmentsContext.fileList
      .filter((x) => !(x as ErpAttachment).isReasonedByInvoice)
      .some((x) => `${x.id}` === `${id}`);
  };

  return (
    <LockFeature feature="note">
      <Panel className={styles.maxHeight} restrictedWidth>
        <ContextMenu
          content={
            <div style={{ padding: '0 1rem' }}>
              <CheckboxRadioItem
                label={t('ERP.ATTACHEMENT_REASONED_BY_INVOICE')}
                control="checkbox"
                checked={attachment?.isReasonedByInvoice}
                onChange={(_event: unknown, value: boolean) => {
                  attachment.isReasonedByInvoice = value;
                  attachmentsContext.markFilesToUpdate(attachment);
                }}
              />
            </div>
          }
        >
          {({ onContextMenu }) => {
            const onRowContextMenu = (e, row) => {
              setMenuItem(row);
              onContextMenu(e);
            };
            return (
              <Attachments
                entity={mask.entity}
                tableLayout={tableLayout}
                canModify={canModify}
                onRowContextMenu={
                  mask.entity === Entities.invoice
                    ? onRowContextMenu
                    : undefined
                }
              />
            );
          }}
        </ContextMenu>
      </Panel>
    </LockFeature>
  );
};
